// Core
import React from 'react';

function Icon(): JSX.Element {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="1em"
      height="1em"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        d="M4 18.1667H20V19.9444H4V18.1667ZM12.8889 12.9862L18.2853 7.58888L19.5422 8.84576L12 16.3889L4.45778 8.84665L5.71467 7.58888L11.1111 12.9844V3.05554H12.8889V12.9862Z"
        fill="currentColor"
      />
    </svg>
  );
}

export default Icon;
